export default {
    beforeMount() {
        import('@lottiefiles/lottie-player').then((module) => {
            const { LottiePlayer } = module;
            this.$vue.use(LottiePlayer);
        });
    }
}
